/**
 * Collection-/Page-Filter und Persistent-Banner für TSSTEC.
 *
 * Verhalten:
 *  - Wenn URL `?vehicle=<handle>` hat → in localStorage speichern, dann filtern + Banner
 *  - Wenn localStorage `tsstec.vehicle` gesetzt → filtern + Banner (auch ohne URL-Param)
 *  - Banner hat Reset-Button → leert localStorage und entfernt Filter
 *
 * Filter-Logik:
 *  - Sucht alle Elemente mit data-fits-vehicles
 *  - Wenn das Vehicle-GID in dem Attribut enthalten ist → behalten
 *  - Sonst: Karte ausblenden (display: none)
 */
(function () {
  const STORAGE_KEY = 'tsstec.vehicle';
  const VEHICLES_URL = (window.tsstec && window.tsstec.vehiclesUrl) || '/assets/vehicles.json';

  function getStored() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); }
    catch (e) { return null; }
  }
  function setStored(v) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(v)); } catch (e) {}
  }
  function clearStored() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  async function resolveVehicleByHandle(handle) {
    const res = await fetch(VEHICLES_URL, { credentials: 'same-origin' });
    if (!res.ok) return null;
    const data = await res.json();
    return (data.vehicles || []).find(v => v.handle === handle) || null;
  }

  function applyFilter(vehicle) {
    if (!vehicle || !vehicle.gid) return { matched: 0, total: 0 };
    const cards = document.querySelectorAll('[data-fits-vehicles]');
    let matched = 0;
    cards.forEach(card => {
      const fits = card.dataset.fitsVehicles || '';
      const container = card.closest('li, .grid__item') || card.parentElement || card;
      if (fits.split(',').includes(vehicle.gid)) {
        container.classList.add('tsstec-fits-vehicle');
        matched++;
      } else {
        container.classList.remove('tsstec-fits-vehicle');
      }
    });
    return { matched, total: cards.length };
  }

  function clearFilter() {
    document.querySelectorAll('.tsstec-fits-vehicle').forEach(el => el.classList.remove('tsstec-fits-vehicle'));
  }

  function buildBanner(vehicle, matched, total) {
    const banner = document.createElement('div');
    banner.className = 'tsstec-fitment-banner';
    let countText = '';
    if (total > 0 && matched > 0) {
      countText = `<span class="tsstec-fitment-banner__count">${matched} von ${total} Teilen auf dieser Seite passen</span>`;
    }
    const fitBase = (window.tsstec && window.tsstec.fitmentCollectionUrl) || '/collections/passende-teile';
    const fitmentUrl = `${fitBase}?filter.p.m.custom.fits_vehicles=${encodeURIComponent(vehicle.gid)}`;
    // Dasselbe Motorrad-Icon wie im Marken-Drawer statt des Emojis —
    // das rendert je nach Betriebssystem völlig unterschiedlich.
    const bikeIcon = `<svg viewBox="0 0 128 128" aria-hidden="true"><path d="m99.09 69 27.57-9.67a2 2 0 0 0 1.34-1.93c0-1.76-.75-4.34-4.33-6.73-6.87-4.57-21.07-6.2-25.11-4.52-.24.11-12.9 12.85-12.9 12.85h-13l-5.09-6c-1.71-2-7.91-8.66-15.41-8.66h-10c-3.45 0-5.36 2-7 3.67a12.54 12.54 0 0 1 -3 2.48l-2.95-.12a21.45 21.45 0 0 1 8.64-9.9 3.6 3.6 0 0 0 -1.37-6.65c-3.23-.43-7.9-.58-11.8 1.17a41.11 41.11 0 0 0 -18.25 20.7c-.29.71-1.8 4.77 0 7a7.09 7.09 0 0 0 3.95 2.78s14.62 3.06 15.06 3.19l-.54 1.94a21.18 21.18 0 1 0 3.85 1.08l.46-1.68a24 24 0 0 1 13.23 15.9l3.37 13.1a2 2 0 0 0 1.94 1.5h31.75a2 2 0 0 0 1.94-1.5l1.39-5.57h3a21.16 21.16 0 1 0 0-4h-2l.84-3.34a25.62 25.62 0 0 1 14.42-17.09zm7.75 20.46h-9.15a9.37 9.37 0 1 1 0 4h9.15a2 2 0 0 0 0-4zm0 15.37a13.38 13.38 0 1 0 -13.21-15.42h-3.82a17.15 17.15 0 1 1 0 4h3.82a13.4 13.4 0 0 0 13.21 11.37zm-64.71-56.5h10c4.6 0 9.4 3.75 12.36 7.25l5.68 6.71a2 2 0 0 0 1.53.71h14.8a2 2 0 0 0 1.42-.59l12.51-12.67c3.14-.87 15.06.29 21 4.26a6.74 6.74 0 0 1 2.17 2.11s-28.26 10.2-29.3 10.82h-36.53s-1.77-3.61-1.77-3.68a28.19 28.19 0 0 0 -18.27-12.25c.07 0 2.71-2.67 4.4-2.67zm-30.78 13.26s-1.07-.64-1.54-1c-1.68-1.27.87-4.67 1.15-5.28a4.38 4.38 0 0 1 2.28 2.41c.22 1.01-.45 2.37-1.89 3.87zm14.2 21.54a9.37 9.37 0 1 1 -4.39-1.13h.54l-2.47 8.81a2 2 0 0 0 1.39 2.46 2 2 0 0 0 2.46-1.39zm12.76 8.28a17.16 17.16 0 1 1 -17.15-17.16 16.75 16.75 0 0 1 2.66.23l-1 3.66a14.55 14.55 0 0 0 -1.66-.14 13.41 13.41 0 1 0 5.48 1.19l1-3.68a17.17 17.17 0 0 1 10.67 15.9zm39.63 5.09h-28.64l-3-11.6a27.94 27.94 0 0 0 -21.5-20.51l-9.06-1.88a7.12 7.12 0 0 0 1.39-5.66 8.17 8.17 0 0 0 -4.28-5.06 37.37 37.37 0 0 1 13.47-13.19 17.42 17.42 0 0 1 8.44-1 25.42 25.42 0 0 0 -9.5 11.68 3.66 3.66 0 0 0 3.25 5l4.22.16a24.2 24.2 0 0 1 19.82 10.89s9.3 19.19 9.35 19.26a11.39 11.39 0 0 0 9.51 5.15h8.21zm2.68-10.73h-9.2a7.42 7.42 0 0 1 -6.11-3.24l-5.6-11.57h29.36c-4.76 3.29-8.45 14.81-8.45 14.81z"/></svg>`;
    banner.innerHTML = `
      <div class="tsstec-fitment-banner__inner">
        <div class="tsstec-fitment-banner__text">
          <span class="tsstec-fitment-banner__label">Mein Motorrad</span>
          <span class="tsstec-fitment-banner__chip">
            <span class="tsstec-fitment-banner__icon">${bikeIcon}</span>
            ${escapeHtml(vehicleLabel(vehicle) || (formatBrand(vehicle.brand) + ' ' + vehicle.model))}
          </span>
          ${countText}
        </div>
        <a class="tsstec-fitment-banner__cta" href="${fitmentUrl}" aria-label="Alle passenden Teile ansehen">
          <span class="tsstec-fitment-banner__btn-text">Alle passenden Teile ansehen</span>
          <svg class="tsstec-fitment-banner__btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h15M13 5.5 19.5 12 13 18.5"/></svg>
        </a>
        <button type="button" class="tsstec-fitment-banner__reset" aria-label="Filter entfernen">
          <span class="tsstec-fitment-banner__btn-text">Filter entfernen</span>
          <svg class="tsstec-fitment-banner__btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M6 18 18 6"/></svg>
        </button>
      </div>
    `;
    banner.querySelector('.tsstec-fitment-banner__reset').addEventListener('click', () => {
      clearStored();
      clearFilter();
      // Fahrzeugsuche und PDP-Fitmentbox mitleeren — ohne das Event bleibt
      // dort die Auswahl stehen, obwohl der Filter weg ist.
      document.dispatchEvent(new CustomEvent('tsstec:vehicle:cleared'));
      // URL ohne Fahrzeug-Parameter aufbauen.
      // 'filter.p.m.custom.fits_vehicles' ist der echte Storefront-Filter,
      // 'vehicle' nur ein Altlast-Parameter früherer Stände.
      const url = new URL(window.location.href);
      const hadFilterParam =
        url.searchParams.has('filter.p.m.custom.fits_vehicles') || url.searchParams.has('vehicle');
      url.searchParams.delete('vehicle');
      url.searchParams.delete('filter.p.m.custom.fits_vehicles');
      const target = url.toString();

      const finish = () => {
        banner.remove();
        // Ohne Filter-Parameter in der URL gibt es nichts neu zu laden.
        if (!hadFilterParam) return;
        // Auf Collection-Seiten das Produktgrid per Section-Rendering
        // austauschen (kein Full-Reload). replaceState zuerst, damit der
        // withFitmentParam-Hook in facets.js das Fahrzeug nicht wieder anhängt.
        if (typeof FacetFiltersForm !== 'undefined' && document.getElementById('ProductGridContainer')) {
          const params = url.searchParams.toString();
          history.replaceState({ searchParams: params }, '', target);
          FacetFiltersForm.renderPage(params, null, false);
        } else {
          window.location.href = target;
        }
      };

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        finish();
        return;
      }
      // Leiste sanft zusammenklappen + hochgleiten, dann Inhalt austauschen
      const h = banner.offsetHeight;
      banner.style.height = h + 'px';
      banner.classList.add('tsstec-fitment-banner--removing');
      void banner.offsetHeight; // Reflow erzwingen
      banner.style.height = '0px';
      setTimeout(finish, 420);
    });
    return banner;
  }

  const BRAND_KEEP_CAPS = new Set(['BMW', 'KTM', 'SYM', 'MV', 'GASGAS', 'CF']);
  function formatBrand(name) {
    if (!name) return '';
    return name.split(/\s+/).map((w) =>
      BRAND_KEEP_CAPS.has(w.toUpperCase()) ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
    ).join(' ');
  }
  function vehicleLabel(v) {
    if (!v) return '';
    const range = v.year_to && v.year_to !== v.year_from ? `${v.year_from}–${v.year_to}` : `${v.year_from}`;
    return `${formatBrand(v.brand)} ${v.model} (${range})`;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  function showBanner(banner) {
    // bevorzugt direkt nach Header / vor Hauptinhalt
    const target = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    target.parentNode.insertBefore(banner, target);
    // Marker für CSS: wenn ein Hero folgt, überlappt die Leiste ihn
    document.body.classList.add('has-fitment-banner');

    // Stuck-Erkennung: kompakter Zustand sobald die Leiste am Header klebt.
    // Sticky-top ist 6.8rem (68px). rect.top <= 69 → Leiste ist gepinnt.
    var STUCK_AT = 69;
    var ticking = false;
    function syncStuck() {
      ticking = false;
      var stuck = banner.getBoundingClientRect().top <= STUCK_AT;
      banner.classList.toggle('tsstec-fitment-banner--stuck', stuck);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(syncStuck);
      }
    }, { passive: true });
    window.addEventListener('resize', syncStuck, { passive: true });
    syncStuck();
  }

  async function init() {
    const url = new URL(window.location.href);
    const handleFromUrl = url.searchParams.get('vehicle');
    let vehicle = getStored();

    if (handleFromUrl && (!vehicle || vehicle.handle !== handleFromUrl)) {
      vehicle = await resolveVehicleByHandle(handleFromUrl);
      if (vehicle) setStored(vehicle);
    }
    if (!vehicle) return;

    const { matched, total } = applyFilter(vehicle);
    showBanner(buildBanner(vehicle, matched, total));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
